export default {
    namespaced: true,

    state() {
        return {
            expanded: true,
        }
    },

    mutations: {
        collapse(state) {
            state.expanded = false;
        },

        expand(state) {
            state.expanded = true;
        },

        toggle(state) {
            state.expanded = !state.expanded;
        }
    },

    getters: {
        expanded(state) {
            return state.expanded;
        }
    }
}